'use strict';

angular.module('sysadmin.components.importsIsams', [
    'sysadmin.services.importsService',
    'shared.services.guidService',
    'shared.components.sbOnOffSwitch',
]).component('importsIsams', {
    templateUrl: '/Scripts/app/sysadmin/components/imports-isams.template.html',
    bindings: {
        organisation: '<',
        isamsDataModel: '<',
        originalIsamsDataModel: '<',
        onChangesNotified: '&',
        beforeSave: '=',
    },
    controller: [
        'importsService',
        'guidService',
        '$scope',
        function importsIsamsController(importsService, guidService, $scope)
        {
            var self = this;
            this.anyChanges = false;

            this.clientSecretObfuscated = {};

            this.$onChanges = function (changes)
            {
                if (typeof self.organisation !== 'undefined' && self.organisation != null)
                {
                    $scope.model = this.isamsDataModel;
                }

                if (changes.isamsDataModel) {
                    this.reset(changes.isamsDataModel);
                }
            };

            this.changesMade = function ()
            {
                $scope.model = this.isamsDataModel;

                var enableSave = this.isDataValid() && this.hasDataChangedFromOriginal();

                if (this.onChangesNotified && typeof (this.onChangesNotified()) === 'function')
                {
                    self.onChangesNotified()(enableSave);
                }
                this.anyChanges = true;
            }.bind(this);

            this.getGuidValidityStyle = function (guidToValidate)
            {
                if (guidService.isValidGuid(guidToValidate) == true)
                {
                    return '';
                }

                return 'alert-danger';
            }.bind(this);

            this.hasDataChangedFromOriginal = function ()
            {
                if (typeof this.isamsDataModel === 'undefined')
                {
                    return false;
                }

                var currentData = this.isamsDataModel;

                if (currentData.baseUrl != this.originalIsamsDataModel.baseUrl || currentData.enabled != this.originalIsamsDataModel.enabled)
                {
                    return true;
                }

                for (var i = 0; i < currentData.isamsBatchApis.length; i++)
                {
                    if (typeof this.originalIsamsDataModel.isamsBatchApis[i].apiKey === 'undefined')
                    {
                        this.originalIsamsDataModel.isamsBatchApis[i].apiKey = '';
                    }

                    // A row with no stored secret arrives as null, so coerce both sides before comparing -
                    // null != '' would otherwise report a change the moment the screen loads.
                    var currentClientSecret = currentData.isamsBatchApis[i].clientSecret || '';
                    var originalClientSecret = this.originalIsamsDataModel.isamsBatchApis[i].clientSecret || '';

                    if (currentData.isamsBatchApis[i].isIncluded != this.originalIsamsDataModel.isamsBatchApis[i].isIncluded ||
                        currentData.isamsBatchApis[i].importEmailAddress != this.originalIsamsDataModel.isamsBatchApis[i].importEmailAddress ||
                        currentData.isamsBatchApis[i].apiKey != this.originalIsamsDataModel.isamsBatchApis[i].apiKey ||
                        currentClientSecret != originalClientSecret ||
                        currentData.isamsBatchApis[i].contactTypes != this.originalIsamsDataModel.isamsBatchApis[i].contactTypes)
                    {
                        return true;
                    }
                }

                return false;
            }.bind(this);

            this.onFocusClientSecret = (isamsBatchApi) => {
                if (this.clientSecretObfuscated[isamsBatchApi.callType]) {
                    isamsBatchApi.clientSecret = '';
                    this.clientSecretObfuscated[isamsBatchApi.callType] = false;
                    this.changesMade();
                }
            }

            this.reset = (isamsDataModelChanges) => {
                this.beforeSave = () => {
                    for (const batchApi of this.isamsDataModel.isamsBatchApis) {
                        if (this.clientSecretObfuscated[batchApi.callType]) {
                            // Never post the censored value back - null tells the API to keep the stored secret.
                            batchApi.clientSecret = null;
                        }
                    }
                }

                // Only a row that arrived with a stored secret is showing a censored value. Flagging a row
                // that had none would make beforeSave discard a secret the user has just typed in.
                for (const batchApi of isamsDataModelChanges.currentValue.isamsBatchApis) {
                    this.clientSecretObfuscated[batchApi.callType] = !!batchApi.clientSecret;
                }
            }

            this.isDataValid = function ()
            {
                if (typeof this.isamsDataModel === 'undefined' ||
                    typeof this.isamsDataModel.baseUrl === 'undefined' ||
                    this.isamsDataModel.baseUrl == '')
                {
                    return false;
                }

                for (var i = 0; i < this.isamsDataModel.isamsBatchApis.length; i++)
                {
                    if (this.isamsDataModel.isamsBatchApis[i].isIncluded &&
                        (typeof this.isamsDataModel.isamsBatchApis[i].apiKey === 'undefined' ||
                        this.isamsDataModel.isamsBatchApis[i].apiKey == ''))
                    {
                        return false;
                    }

                    if (this.isamsDataModel.isamsBatchApis[i].isIncluded &&
                        !guidService.isValidGuid(this.isamsDataModel.isamsBatchApis[i].apiKey))
                    {
                        return false;
                    }
                }

                return true;
            }.bind(this);
        }
    ]
});
